import { Injectable } from '@angular/core';
import { RestResponse } from 'app/modules/common/entities/rest.response.model';
import { ApiService } from 'app/modules/common/services/api.service';
import { Observable } from 'rxjs';
import API from '../../common/services/api.config.json';

@Injectable({
    providedIn: 'root'
})
export class DespachoService {
    constructor(private apiService: ApiService) { }

    GetAllCoordinatorsList(year: string): Observable<RestResponse> {
        const url = API.Coordinator.getAllCoordinatorsListDespachoCoordinadores
            .replace('{year}', year);

        return this.apiService.get(url);
    }

    GetCoordinatorVisitWordReport(id: string): Observable<RestResponse> {
        const url = API.Coordinator.getCoordinatorVisitWordReport.replace('{id}', id);
        return this.apiService.get(url);
    }

    GetCoordinatorVisitWordReportByRange(body: any): Observable<RestResponse> {
        return this.apiService.post(API.Coordinator.getCoordinatorVisitWordReportByRange, body);
    }
}
